/**
 * Skeleton — animated pulse placeholder block.
 * Compose these to match the real layout of a loading screen.
 *
 * Usage:
 *   <Skeleton className='h-4 w-32' />          // short text line
 *   <Skeleton className='h-40 w-full' />        // image block
 */
export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse rounded-md bg-zinc-200 ${className}`} />;
}
